<template>
  <div
    id="dropdown-card"
    :class="{'text-center': $vuetify.breakpoint.xs}"
  >
    <v-card id="survey-dropdown">
      <h3>Select a survey from the list below:</h3>
      <v-select
        v-model="selectedSurveyNumberForExhibits"
        :items="surveys"
        return-object
        item-text="name"
        label="Survey"
        @change="updateSelectedSurveyNumberForExhibits(selectedSurveyNumberForExhibits)"
      />
    </v-card>
    <br>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: `survey/getField`,
  mutationType: `survey/updateField` // custom mutation that will add selected survey question names to vuex store
});

export default {
  name: "SurveyDropdown",
  computed: {
    ...mapState({ surveys: state => state.survey.surveys }),
    ...mapFields(["selectedSurveyNumberForExhibits"]),
  },
  mounted() {
    this.fetchSurveys()
  },
  methods: {
    ...mapActions("survey", [
      "updateSelectedSurveyNumberForExhibits",
      "fetchSurveys"
    ]),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#survey-dropdown {
  padding: 2%;
  height: 100%;
}
</style>
